import { render } from "./PaymentSelection.vue?vue&type=template&id=5c9785ad&scoped=true"
const script = {}

import "./PaymentSelection.vue?vue&type=style&index=0&id=5c9785ad&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9785ad"]])

export default __exports__